/** The product mark: a delta of three branches over a ledger rule (original artwork). */
export function ProductMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <rect width="32" height="32" rx="7" fill="#0d544c" />
      <path
        d="M16 25V15.5M16 15.5 9.5 7.5M16 15.5l6.5-8M16 15.5V6.5"
        fill="none"
        stroke="#ddb56d"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 25.5h14" fill="none" stroke="#eef7f5" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
